// extracted by mini-css-extract-plugin
module.exports = {"vanmi0l":"vanmi0l","c1sleahn":"c1sleahn"};